import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { BookOpen, Plane } from 'lucide-react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';

export const StatisticsContent = ({ monthlyProgressData }) => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-800">İstatistikler & Analitik</h2>
        <p className="text-gray-500">Platform performansı ve kullanıcı metrikleri</p>
      </div>

      {/* Aylık İlerleme */}
      <Card className="border-0 shadow-lg">
        <CardHeader>
          <CardTitle>Aylık Ders Tamamlama Trendi</CardTitle>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={monthlyProgressData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis dataKey="name" stroke="#94a3b8" />
              <YAxis stroke="#94a3b8" />
              <Tooltip />
              <Bar dataKey="tamamlanan" fill="#3b82f6" radius={[4, 4, 0, 0]} name="Tamamlanan Ders" />
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      {/* Eğitim İstatistikleri */}
      <div className="grid lg:grid-cols-2 gap-6">
        <Card className="border-0 shadow-lg">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <BookOpen className="w-5 h-5 text-blue-500" />
              İngilizce Eğitimi
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {['A0', 'A1', 'A2', 'B1', 'B2', 'C1'].map((level, idx) => (
              <div key={level} className="space-y-1">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">{level} Seviyesi</span>
                  <span className="font-medium">{[15, 25, 30, 18, 8, 4][idx]}%</span>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-2">
                  <div 
                    className="bg-blue-500 h-2 rounded-full transition-all"
                    style={{ width: `${[15, 25, 30, 18, 8, 4][idx]}%` }}
                  />
                </div>
              </div>
            ))}
          </CardContent>
        </Card>

        <Card className="border-0 shadow-lg">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Plane className="w-5 h-5 text-sky-500" />
              Kabin Memurluğu Eğitimi
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {[
              { name: 'Mülakat Hazırlık', progress: 45 },
              { name: 'Havayolları Bilgisi', progress: 32 },
              { name: 'Acil Durum Prosedürleri', progress: 28 },
              { name: 'Yolcu Hizmetleri', progress: 22 },
              { name: 'Havacılık Terimleri', progress: 18 },
            ].map(item => (
              <div key={item.name} className="space-y-1">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">{item.name}</span>
                  <span className="font-medium">{item.progress}%</span>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-2">
                  <div 
                    className="bg-sky-500 h-2 rounded-full transition-all"
                    style={{ width: `${item.progress}%` }}
                  />
                </div>
              </div>
            ))}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default StatisticsContent;
